<!--
2021-11-29 CHP 播放YouTube视频
2021-11-30 CHP 处理横、竖屏切换时的变化
-->
<template>
  <div class="container-fluid">
    <div class="closeBar">
      <img :src="closeImg" alt="" @click="handleClose"/>
    </div>
    <div class="js-video [vimeo, widescreen]" :style="frameStyle">
      <video :src="url" frameborder="0" allowfullscreen controls/>
    </div>
  </div>
</template>
<script>
import closeImg from '@/assets/images/common/closeDeposit.svg'

export default {
  name: 'UpiVideo',
  props: ['handleClose', 'url'],
  data () {
    return {
      closeImg,
      screenHeight: 0,
      screenWidth: 0,
      frameStyle: {
      },
      videoID: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.container-fluid {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000000;
  .js-video {
    position: absolute;
    top: 15vw;
    left: 0;
    width: 100vw;
    height: calc(100vh - 30vw);
  }

  .js-video.widescreen {
    /*padding-bottom: 56.34%;*/
  }

  .js-video.vimeo {
    padding-top: 0;
  }

  .js-video embed, .js-video iframe, .js-video object, .js-video video {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }

  .closeBar {
    position: absolute;
    top: 0;
    width: 100vw;
    height: 15vw;
    background: #000000;
    display: flex;
    justify-content: flex-end;
    padding: 0 2vw 0 0;
    align-items: center;

    img {
      width: auto;
      height: 7vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UpiVideo/index.vue